import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import colors from 'vuetify/es5/util/colors';
import es from 'vuetify/es5/locale/es';
import ca from 'vuetify/es5/locale/ca';
import en from 'vuetify/es5/locale/en';

Vue.use(Vuetify);

const opts = {
	theme: {
		light: true,
		themes: {
			light: {
				primary: '#013476',
				secondary: '#e56208',
				accent: colors.orange.darken1,
				error: colors.red.darken1
			}
		}
	},
	icons: {
		iconfont: 'fa'
	},
	lang: {
		locales: { es, ca, en },
		current: 'es'
	}
};

export default new Vuetify(opts);
